import Content from "components/Content";
import Label from "components/Label";
import React, { FC } from "react";
import Quotes from "../../../../../public/pricing/what_members_say/quotes.svg";

import { comments } from "./contants";
import styles from "./styles.module.scss";

const WhatMembersSay: FC = () => {
  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <Label className={styles.title} color="primary" variant="h-centered">
        What our members say about Humming Homes
      </Label>
      <div className={styles.comments}>
        {comments.map(({ content, author, icon }) => (
          <div className={styles.comment}>
            <Quotes className={styles.quotes} />
            <Label className={styles.content} variant="s" color="secondary">
              {content}
            </Label>
            <div className={styles.authorWrapper}>
              {icon}
              <Label
                className={styles.author}
                color="secondary"
                variant="capitalized-s"
              >
                {author}
              </Label>
            </div>
          </div>
        ))}
      </div>
    </Content>
  );
};

export default WhatMembersSay;
